/* The Wall Studio — minimal theme JS. No dependencies. */
(function () {
  'use strict';

  var doc = document;

  /* ---------- Drawers ---------- */
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    doc.body.classList.remove('body-locked');
    if (d.__opener && d.__opener.focus) d.__opener.focus();
  }
  function openDrawer(d, opener) {
    if (!d) return;
    d.__opener = opener || null;
    d.classList.add('is-open');
    doc.body.classList.add('body-locked');
    var f = d.querySelector('[data-drawer-close]');
    if (f) f.focus();
  }

  doc.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-drawer-open]') : null;
    if (open) {
      e.preventDefault();
      openDrawer(doc.getElementById(open.getAttribute('data-drawer-open')), open);
      return;
    }
    var close = e.target.closest ? e.target.closest('[data-drawer-close]') : null;
    if (close) {
      e.preventDefault();
      closeDrawer(close.closest('.drawer'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('drawer__scrim')) {
      closeDrawer(e.target.closest('.drawer'));
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = doc.querySelector('.drawer.is-open');
    if (open) closeDrawer(open);
    var sp = doc.querySelector('.search-panel.is-open');
    if (sp) sp.classList.remove('is-open');
  });

  /* ---------- Search toggle ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-search-toggle]') : null;
    if (!t) return;
    e.preventDefault();
    var panel = doc.getElementById('SearchPanel');
    if (!panel) return;
    var willOpen = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', willOpen);
    t.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  /* ---------- Quantity steppers ---------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var val = parseInt(input.value || '1', 10);
    val += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    if (val < min) val = min;
    input.value = val;
  });

  /* ---------- Money formatting (no regex, keeps the shop format) ---------- */
  function group(intPart) {
    var out = '';
    var c = 0;
    for (var i = intPart.length - 1; i >= 0; i--) {
      out = intPart.charAt(i) + out;
      c++;
      if (c % 3 === 0 && i > 0) out = ',' + out;
    }
    return out;
  }

  function money(cents, format) {
    var fixed = (cents / 100).toFixed(2).split('.');
    var noDecimals = format.indexOf('no_decimals') !== -1;
    var value = group(fixed[0]) + (noDecimals ? '' : '.' + fixed[1]);
    var open = format.indexOf('{{');
    var close = format.indexOf('}}');
    if (open === -1 || close === -1) return value;
    return format.slice(0, open) + value + format.slice(close + 2);
  }

  /* ---------- Product variants ---------- */
  function initProductForm(root) {
    if (root.__init) return;
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    root.__init = true;

    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var addText = addBtn && addBtn.querySelector('[data-add-text]');
    var directCheckout = root.querySelector('[data-direct-checkout]');
    var fmt = root.getAttribute('data-money-format') || '{{amount}}';
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-opt-input]'));
    if (!inputs.length) return;

    function selected() {
      var vals = [];
      inputs.forEach(function (i) {
        if (i.checked) vals[parseInt(i.getAttribute('data-opt-index'), 10)] = i.value;
      });
      return vals;
    }

    function match(vals) {
      return variants.filter(function (v) {
        return vals.every(function (val, i) { return val === undefined || v.options[i] === val; });
      })[0];
    }

    function refresh() {
      var vals = selected();
      var v = match(vals);

      inputs.forEach(function (i) {
        var idx = parseInt(i.getAttribute('data-opt-index'), 10);
        var probe = vals.slice();
        probe[idx] = i.value;
        i.disabled = !match(probe);
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-opt-selected]'), function (el) {
        var idx = parseInt(el.getAttribute('data-opt-selected'), 10);
        el.textContent = vals[idx] || '';
      });

      if (!v) {
        if (directCheckout) directCheckout.disabled = true;
        if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (directCheckout) directCheckout.disabled = !v.available;
      if (priceEl) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="money--was">' + money(v.compare_at_price, fmt) + '</span>';
        }
        html += '<span class="money">' + money(v.price, fmt) + '</span>';
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        if (addText) addText.textContent = v.available ? (addBtn.getAttribute('data-add-label') || 'Add to cart') : 'Sold out';
      }

      if (window.history && history.replaceState && v.id) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        } catch (err) {}
      }
    }

    inputs.forEach(function (i) { i.addEventListener('change', refresh); });
    refresh();
  }

  /* ---------- Cart count ---------- */
  function cartCountRefresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(doc.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- Add to cart ---------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-ajax-cart]') : null;
    if (!form) return;
    if (e.submitter && e.submitter.hasAttribute('data-direct-checkout')) return;
    var hasFiles = Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (field) { return field.files && field.files.length; });
    if (hasFiles) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add]');
    var text = btn && btn.querySelector('[data-add-text]');
    var prev = text ? text.textContent : '';
    if (text) text.textContent = 'Adding...';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (text) text.textContent = res.data.description || 'Unavailable';
          setTimeout(function () { if (text) text.textContent = prev; }, 2400);
          return;
        }
        if (text) text.textContent = 'Added';
        cartCountRefresh();
        setTimeout(function () { if (text) text.textContent = prev; }, 1800);
      })
      .catch(function () { form.submit(); });
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = doc.querySelectorAll('.reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function initAll() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-product-root]'), initProductForm);
    initReveal();
  }

  if (doc.readyState !== 'loading') initAll();
  else doc.addEventListener('DOMContentLoaded', initAll);

  doc.addEventListener('shopify:section:load', initAll);
  doc.addEventListener('shopify:section:select', initAll);
})();